// packages/cms/src/gql/talentSearch.ts
import { gql } from '@apollo/client';
import { TALENT_SHARED_FIELDS_FRAGMENT } from './talents';

export const SEARCH_TALENTS = gql`
  query SearchTalents($input: TalentSearchInput!, $pagination: Pagination) {
    searchTalents(input: $input, pagination: $pagination) {
      docs {
        talent {
          ...TalentFragment
        }
        distance
        favorite {
          _id
          talentId
          type
          rating
          metadata {
            notes
            tags
            priority
            campaign
          }
          createdAt
        }
      }
      meta {
        totalDocs
        page
        totalPages
        hasNextPage
        hasPrevPage
        nextPage
        prevPage
        limit
        pagingCounter
      }
    }
  }
  ${TALENT_SHARED_FIELDS_FRAGMENT}
`;

export const GET_SEARCH_PRESETS = gql`
  query GetSearchPresets {
    getSearchPresets {
      _id
      name
      description
      filters
      visibility
      createdBy {
        _id
        role
      }
      createdAt
      updatedAt
    }
  }
`;

export const SEARCH_TALENT_FILTERS = gql`
  query SearchTalentFilters($input: TalentSearchInput!) {
    searchTalentFilters(input: $input) {
      professionIds {
        value
        label
        count
        groupLabel
      }
      specialtyIds {
        value
        label
        count
        groupLabel
      }
      softSkillIds {
        value
        label
        count
      }
      certificateIds {
        value
        label
        count
      }
      diplomaTypes {
        value
        label
        count
      }
      cities {
        value
        label
        count
      }
      countries {
        value
        label
        count
      }
      availability {
        value
        label
        count
      }
      currentStatus {
        value
        label
        count
      }
      contractTypes {
        value
        label
        count
      }
      languageIds {
        value
        label
        count
      }
      languageLevelIds {
        value
        label
        count
      }
      tags {
        value
        label
        count
      }
      priority {
        value
        label
        count
      }
      jobOfferScoringStates {
        value
        label
        count
      }
      resumeReadinessStatuses {
        value
        label
        count
      }
      jobOfferScoringRange {
        min
        max
      }
      experienceRange {
        min
        max
      }
      expectedSalaryRange {
        min
        max
      }
      maxRating
    }
  }
`;

export const CREATE_SEARCH_PRESET = gql`
  mutation CreateSearchPreset($input: SearchPresetInput!) {
    createSearchPreset(input: $input) {
      _id
      name
      description
      filters
      visibility
      createdBy {
        _id
        role
      }
      createdAt
    }
  }
`;

export const UPDATE_SEARCH_PRESET = gql`
  mutation UpdateSearchPreset($id: ID!, $input: SearchPresetInput!) {
    updateSearchPreset(id: $id, input: $input) {
      _id
      name
      description
      filters
      visibility
      updatedAt
    }
  }
`;

export const DELETE_SEARCH_PRESET = gql`
  mutation DeleteSearchPreset($id: ID!) {
    deleteSearchPreset(id: $id)
  }
`;
